export default __webpack_public_path__ + "static/media/mug.4ce09c5a.png";